import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false, recruiterOnly = false }) {
  const { user } = useAuth();
  const location = useLocation();

  if (location.state?.user && user === null) {
    // Skip loading flash right after AuthCallback navigation
  }

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background" data-testid="auth-loading-spinner">
        <div className="w-10 h-10 border-2 border-accent border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (user === false) {
    return <Navigate to="/login" replace />;
  }

  if (adminOnly && user.role !== "admin") {
    return <Navigate to="/dashboard" replace />;
  }

  if (recruiterOnly && user.role !== "recruiter") {
    return <Navigate to="/dashboard" replace />;
  }
  if (!recruiterOnly && user.role === "recruiter") {
    return <Navigate to="/recruiter/dashboard" replace />;
  }

  return children;
}
